import type { FaireProductEntity } from "../../entity_types/product";

export const p_2yjk6faajr: FaireProductEntity = {
  token: "p_2yjk6faajr",
  type: "product",
  name: "NEW Fantasticats Pet Bowl",
  brandToken: "b_65zgi875pr",
  brandName: "Laurel Burch Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/7a6f2b9872c9f061c738c24b31e053fd3725c5cf7d5aa8b4c0425e7ae77fbd01.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1832ab1e66934e6d734b8ed230783f3f53fa9f6d96da84322b9b62e64d82d2c.png",
  ],
  priceDollars: 10.35,
  description:
    "Let your feline dine in bright, beautiful style! Our vibrant, new pet bowl design is based on an early painting of Laurel’s signature rainbow-colored kitties. With room for one cup of food or water, it’s both practical and paw-sitively fun.\n\n• Removable stainless steel bowl\n• Colorful melamine base, anti-slip rubber bottom\n• Half-moon notch in base makes it easy to pick up\n• Dishwasher safe, top rack; do not microwave\n\nItem Number: PB005\nCapacity: 1-cup capacity \nDimensions: 1.25” bowl depth, 4.5” diameter. Base is 2”H with 5.5” diameter \nMaterial: Melamine, rubber; stainless steel\n\n",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:06.461Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
